import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../../../store/store';
import {
  MentorDTO,
  MentorListRequest,
  MentorListResponse,
} from '../../application/dto/Mentor.dto';

const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:4000';
const API_BASE_URL = `${API_HOST}/v1/`;

export const mentorApi = createApi({
  reducerPath: 'mentorApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: 'include',
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).auth?.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Mentor'],
  endpoints: build => ({
    getMentorsList: build.query<MentorListResponse, MentorListRequest>({
      query: params => ({
        url: '/mentors',
        method: 'GET',
        params: {
          page: params.page,
          limit: params.limit,
          search: params.query,
        },
      }),
      transformResponse: (response: { data: MentorListResponse }) =>
        response.data,
      providesTags: ['Mentor'],
    }),
    getMentorById: build.query<MentorDTO, number>({
      query: id => ({
        url: `/mentors/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: { data: MentorDTO }) => response.data,
      providesTags: (_result, _error, id) => [{ type: 'Mentor', id }],
    }),
  }),
});

export const { useGetMentorsListQuery, useGetMentorByIdQuery } = mentorApi;
